import { Select as AntSelect, SelectProps } from "@basic-components";
export const Select = ({ label = '', isView, value, options = [], ...rest }: { label: string; isView?: boolean } & SelectProps) => {
  if (isView) {
    return options.find((item) => item.value === value)?.label || '--';
  }
  return (
    <AntSelect placeholder={`请选择${label}`} className="w-full" options={options} value={value} {...rest} />
  );
};